module.exports = __webpack_public_path__ + "img/logo.f42916b0.svg";